export default __webpack_public_path__ + "road-map-800-0f8e13c1883aaff15bc8664a4406c6b8.png";